import { render, staticRenderFns } from "./StudentAddView.vue?vue&type=template&id=6a416fef"
import script from "./StudentAddView.vue?vue&type=script&lang=js"
export * from "./StudentAddView.vue?vue&type=script&lang=js"
import style0 from "./StudentAddView.vue?vue&type=style&index=0&id=6a416fef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports